import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Button as AntdButton } from 'antd';
import { AntdButton as Button } from '../Button/Button';

import { useWindowSize, sizes } from 'helpers/MediaHelper';

const StyledGroupSaveButton = styled(Button)`
  width: ${(props) => (props.isMobile ? '50%' : 'auto')};
  justify-content: center;
  border-top-right-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
`;

const StyledGroupCancelButton = styled(Button)`
  width: ${(props) => (props.isMobile ? '50%' : 'auto')};
  justify-content: center;
  border-top-left-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
`;

const StyledAntdButtonGroup = styled(AntdButton.Group)`
  margin-top: ${(props) => (props.isMobile ? '16px' : '0px')};
  width: ${(props) => (props.isMobile ? '100%' : 'auto')};
  .ant-btn-group .ant-btn-primary:first-child:not(:last-child) {
    border-right-color: transparent;
  }
`;

const AssociationsSelectorActionGroup = ({ currentlySelectedRows, saveAction, cancelAction }) => {
  const [width] = useWindowSize();
  const isMobile = width <= sizes.mobile;

  return (
    <StyledAntdButtonGroup isMobile={isMobile}>
      <StyledGroupSaveButton
        data-testid="associations-save-button"
        type="primary"
        label="Save"
        isMobile={isMobile}
        size={isMobile ? 'large' : 'default'}
        onClick={() => saveAction(currentlySelectedRows)}
      />
      <StyledGroupCancelButton
        data-testid="associations-cancel-button"
        label="Cancel"
        isMobile={isMobile}
        size={isMobile ? 'large' : 'default'}
        onClick={() => cancelAction()}
      />
    </StyledAntdButtonGroup>
  );
};

AssociationsSelectorActionGroup.propTypes = {
  saveAction: PropTypes.func.isRequired,
  cancelAction: PropTypes.func.isRequired,
};

export { AssociationsSelectorActionGroup };
